import type { VideoEmbedType } from 'components/UI/FoundationPlayer/config.js';
import type { GeoCountries, VideoEncoding, VideoProps } from '../types/videoTypes.d.ts';

export const COUNTRIES_DACH = ['de', 'at', 'ch'];
export const COUNTRIES_DACHLILU = ['de', 'at', 'ch', 'li', 'lu'];

export const geoAllowed = (videoAllowedForCountry: GeoCountries = 'de', clientCountryCode?: string) => {
  if (videoAllowedForCountry === 'world') {
    return true;
  }

  if (!clientCountryCode) {
    return false;
  }

  if (videoAllowedForCountry === 'dachlilu') {
    return COUNTRIES_DACHLILU.includes(clientCountryCode.toLowerCase());
  }

  if (videoAllowedForCountry === 'dach') {
    return COUNTRIES_DACH.includes(clientCountryCode.toLowerCase());
  }

  return clientCountryCode.toLowerCase() === 'de';
};

export const getVideoEncoding = (
  encodings?: Array<VideoEncoding>,
  format: string = 'progressive'
): VideoEncoding | undefined => {
  if (!encodings) {
    return undefined;
  }

  const pin = encodings.find(({ value }) => value['encoding-format'].value === format);

  if (pin) {
    return pin;
  }

  return encodings.length > 0 ? encodings[0] : undefined;
};

export const getVideoDuration = (video: VideoProps): number | undefined => {
  if (!video?.fields?.encoding && !video?.duration) {
    return undefined;
  }

  if (video?.fields?.encoding) {
    const encoding = getVideoEncoding(video?.fields?.encoding);

    if (encoding?.value?.duration) {
      return parseFloat(encoding.value.duration.value) / 1000;
    }

    return video.duration ?? undefined;
  }

  return video.duration;
};

export const getVideoEmbedType = (index?: number): VideoEmbedType | undefined => {
  if (!index) return undefined;
  if (index && index <= 2) return 'intro';
  return 'inline';
};

export const hasRelatedVideoKeyWord = (text: string): boolean => {
  if (!text) return false;
  const lowerText = text.toLowerCase();
  return lowerText.includes('im video') || lowerText.includes('video-tipp') || lowerText.includes('video tipp');
};
